import { splunkStackResourceInstaller } from "./resource/index.tsx";
import type { SplunkStackIntegrationInstaller } from "./types.ts";

export const splunkStackInstaller: SplunkStackIntegrationInstaller = {
  components: {
    settings: { items: {} },
    base: {},
    "iam-write": splunkStackResourceInstaller,
  },
};
